import ApiOperation from "adapter/ApiOperation";
import Constants from "utils/Constants";

const factory = {
    getListReceiver: (payload) => {

        let params = {
            view: "owner"
        };

        let data = {
            subAttribute: {}
        }

        if (payload[Constants.QueryParams.SEARCH.VALUE]) {
            params['keyword'] = payload[Constants.QueryParams.SEARCH.VALUE];
        }

        if (payload[Constants.QueryParams.OFFSET.VALUE]) {
            params['page'] = payload[Constants.QueryParams.OFFSET.VALUE];
        } else {
            params['page'] = 1;
        }

        if (payload[Constants.QueryParams.LIMIT.VALUE]) {
            params['limit'] = payload[Constants.QueryParams.LIMIT.VALUE];
        } else {
            params['limit'] = Constants.PAGINATION.LIMIT;
        }

        if (payload[Constants.QueryParams.ATTRIBUTES.VALUE]) {
            data['mainAttribute'] = JSON.parse(payload[Constants.QueryParams.ATTRIBUTES.VALUE]);
        }

        let url = `/rest/api/v1/management/receiver/filter/${payload[Constants.QueryParams.TYPE.VALUE]}`;
        return ApiOperation.request({
            url: url,
            method: 'POST',
            params: params,
            data: data
        })
    },
    updateReceiver: (payload) => {
        let url = "/rest/api/v1/management/receiver";
        return ApiOperation.request({
            url: url,
            method: 'PUT',
            data: payload
        })
    },
    deleteReceiver: (payload) => {
        let url = `/rest/api/v1/management/receiver/${payload?.id}`;
        return ApiOperation.request({
            url: url,
            method: 'DELETE',
            data: {
                mode: payload?.mode
            }
        })
    },
    createReceiver: (payload) => {
        let url = "/rest/api/v1/management/receiver";
        return ApiOperation.request({
            url: url,
            method: 'POST',
            data: payload
        })
    },
    getDetailReceiver: (payload) => {
        let url = `/rest/api/v1/management/receiver/${payload}`;
        return ApiOperation.request({
            url: url,
            method: 'GET',
        })
    },
    getHolonTemplateDetail: (payload) => {
        let url = `/rest/api/v1/management/receiver/template`;
        return ApiOperation.request({
            url: url,
            method: 'GET',
        })
    },
}

export default factory;